import { RoutePath } from "@/models";

import * as Fa from "react-icons/fa";
import * as Ai from "react-icons/ai";

export const sidebarData: RoutePath[] = [
  {
    title: "Home",
    path: "/#hero",
    icon: <Ai.AiFillHome />,
    cName: "nav-text",
  },
  {
    title: "Projects",
    path: "/#projects",
    icon: <Fa.FaBuffer />,
    cName: "nav-text",
  },
  {
    title: "About Me",
    path: "/#aboutMe",
    icon: <Fa.FaUserAstronaut />,
    cName: "nav-text",
  },
  {
    title: "Skills",
    path: "/#skills",
    icon: <Fa.FaBrain />,
    cName: "nav-text",
  },
];
